'use client'
import { useState } from "react";
import styles from "@/terms/page.module.css";
import Image from "next/image";
import Link from "next/link";

export default function Terms() {
    const termsArray = [
        {
            title: "Introduction",
            description: <div>
                Welcome to PArent.ge, Georgia's leading car rental service with 14 years of excellence. We offer convenient, affordable rentals across major cities and airports, with 24/7 support in multiple languages and seamless border crossing options to Armenia and Azerbaijan.
                <br /><br />
                By using our services, you agree to the Terms and Conditions outlined below, designed to ensure a safe, enjoyable, and hassle- free experience for all our customers.
            </div>
        },
        {
            title: "Agreement for renting a vehicle",
            description: <div>
                This section outlines the standard <Link
                    href="/agreement"
                    target="_blank"
                    rel="noopener noreferrer"
                >Agreement for renting a vehicle</Link> through our website.
            </div>
        },
        {
            title: "Eligibility and Requirements for Renters",
            description: <ul>
                <li>
                    Driving License: Any valid license that has :  1.  Name, 2.  Age, 3. Validity of driving license, and category printed in Latin or or Cyrillic alphabet iv valid on Georgia for 1 year after arrival and is accepted by the rental.
                </li>
                <li>
                    If your driving license has info in language it can be translated by a local notary, however it is recommended to have an international driving license as there are some driving licenses that have some sections missing and cannot be used after translation.
                </li>
                <li>
                    Age Restrictions: Drivers must be at least 21 years old with 1 year of driving experience. 
                </li>
            </ul>
        },
        {
            title: "Rental Reservations",
            description: <ul>
                <li>
                    Booking the Vehicle: Reservation can be done online, email or phone/whatsapp  prepayment
                </li>
                <li>
                    Changing the Booking: Free changes to bookings are allowed up to 24 hours before the start of the rental, either by email or phone.
                </li>
                <li>
                    Canceling the Booking: Bookings can be canceled without charge up to 24 hours before the rental begins, through the customer account, email, or hotline.
                </li>
            </ul>
        },
        {
            title: "Payment Conditions and Methods",
            description: <ul>
                <li>
                    No Prepayment for Online Reservations: No prepayment needed for any reservation.
                </li>
                <li>
                    Payment Upon Arrival: Credit card payments are processed at vehicle pickup. Full payment is required on the first rental day for a no-deposit rental.
                </li>
                <li>
                    Payment Methods: Acceptance of cash, debit/credit cards (with a 3.5% surcharge), and bank transfers. Payments in GEL are based on the official exchange rate; bank transfers can be made in EUR or USD.
                </li> 
            </ul>
        },
        {
            title: "Deposit and Fees",
            description: <ul>
                <li>
                    Zero Deposit Policy: All rentals are deposit-free, except for a few premium vehicles that require a deposit, as indicated during the booking process.
                </li>
                <li>
                    Fees for Damages and Losses: Charges include 60 EUR for each damaged on off-road only, tires damaged on asphalt road are insured tires and 100 EUR for lost vehicle keys. These are not covered by insurance. 
                </li>
            </ul>
        },
        {
            title: "Insurance Coverage",
            description: <ul>
                <li>
                    Casco Insurance: 100% Full Casco Insurance Coverage in case of accidents, theft, fire, or third-party damage. Includes third-party insurance in the amount of $50,000 and covers all accessories without franchise or deductions. 
                </li>
                <li>
                    Exclusions: Personal items inside the vehicle are not covered, as well as passenger insurance that should be covered by personal travel insurance according to Georgian law.
                </li>
            </ul>
        },
        {
            title: "Vehicle Use and Restrictions",
            description: <ul>
                <li>
                    <div>Territorial Restrictions: Vehicles categorized in three categories:</div>
                    <b>For City / Highway</b> - are not allowed on any off-road. <b>Easy Off-Road</b> - are allowed on any road except Tusheti. <b>For Difficult Off-road</b>, any official road in Georgia. None of our vehicles are allowed to cross occupied territories (Abkhazia & Osetia). <b>Campers</b> – have additional terms of use listed below. 
                </li>
                <li>
                    Cross-Border Rentals: Allowed to Armenia with a special permit and additional insurance. Notary-issued permits and costs for crossing borders can be issued in the booking process for the fee of 90 EUR / per country.  
                </li>
                <li>
                    Campers: Camping vehicles are allowed on non-official roads in Georgia (lakes, forest, etc.), however any damage made on this territory is not covered by insurance and must be paid by a customer. Any existing road in parks or any proper and visible car trail is considered as a road and has insurance coverage.
                </li>
            </ul>
        },
        {
            title: "Maintenance and Breakdown Assistance",
            description: <ul>
                <li>
                    Renter Responsibilities: Immediate reporting of vehicle problems to avoid further damage and for safety reasons.
                </li>
                <li>
                    Company Support: Provision of vehicle replacement in case of malfunction or breakdown, applicable in Georgia and neighboring countries.
                </li>
            </ul>
        },
        {
            title: "Rental Period, Late Returns, and Early Returns",
            description: <ul>
                <li>
                    Timely Return: Charges for late returns range from 50% of the daily rate (3-8 hours late) up to doubling lay doubling the daily rate for delays over 8 hours, unless previously agreed upon.
                </li>
                <li>
                    Early Return: A 40% refund is provided for unused rental days if the vehicle is returned early, with no refund for returns less than 24 hours early.
                </li>
            </ul>
        },
        {
            title: "Delivery and Collection",
            description: <ul>
                <li>
                    Pickup and Drop off of the vehicles can be done 24/7 for any online pre-booked vehicles. In all offices and Airports of Georgia.
                </li>
                <li>
                    Delivery to any place in the city is charged 14 EUR and can be selected during booking process
                </li>
                <li>
                    24/7 Vehicle Delivery and Collection: Any booking is executed at any time or holiday, you will receive the vehicle any time specified in the booking for no extra charge.
                </li>
            </ul>
        },
        {
            title: "Rules Regarding Fines and Violations ",
            description: <ul>
                <li>
                    Traffic and Parking Fines: Renters are responsible for compensating any fines incurred during the rental period. Documentation for payment will be provided.
                </li>
                <li>
                    Drinking and Driving: Strict penalties include a 500 EUR charge from PArent, vehicle confiscation, and a 6-month driving license suspension by Georgian police. Tolerance for alcohol in Georgia is 0.3 promilles.
                </li>
            </ul>
        },
        {
            title: "Campers & Camping Equipment",
            description: <ul>
                <li>
                    Territorial Restrictions: Camping vehicles are allowed on non-official roads in Georgia (lakes, forest roads, etc.),
                </li>
                <li>
                    Insurance: All insurance terms apply to Camping vehicles however as there is no insurance coverage for any damage made to the vehicle done on non-official roads any damage made to the vehicle must be covered by the customer only.  Fees for the vehicle repair will be provided by PArent, if there is any misunderstanding with the payment, invoice for the payment amount can be provided by the insurance company. Note: Usually, the insurance company counts much bigger amounts as we try to take minimal and fair charges that we need for repairs.
                </li>
                <li>
                    Malfunctions: All standard terms also apply to camping vehicles, excluding malfunction on non-official roads. In case of malfunction on restricted territories, PArent is responsible for a vehicle change, but the fees for delivering the vehicle to the destination must be covered by the customer. The standard Fee for the change is 0.5 EUR per km from Tbilisi city.
                </li>
                <li>
                    Camping Equipment: Any camping equipment provided together with a camping car is not insured, any loss or damage must be covered by a customer, list of equipment and fees for damage or loss are provided as an annex to your rental contract. Fees include only the price for equipment, no extra penalties for any damage or loss.
                </li>
            </ul>
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);

    const toggleSection = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={styles.terms}>
            <h1 className={styles.title}>TERMS</h1>
            {termsArray.map((term, index) => (
                <div key={index} className={styles.termSection}>
                    <button
                        type="button"
                        className={styles.termHeader}
                        onClick={() => toggleSection(index)}
                        aria-expanded={openIndex === index}
                        aria-controls={`term-content-${index}`}
                    >
                        <span>{term.title}</span>
                        <span className={styles.icon}>
                            {openIndex === index ?
                                <Image src="/assets/images/icons/circle-arrow-up.svg" width="33" height="33" alt="arrow-up" />
                                :
                                <Image src="/assets/images/icons/circle-arrow-down.svg" width="33" height="33" alt="arrow-down" />
                            }
                        </span>
                    </button>
                    {openIndex === index && (
                        <div id={`term-content-${index}`} className={styles.termContent}>
                            {term.description}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
